import React from 'react';
import { SectionWrapper } from './SectionWrapper';
export function ProblemSection() {
  return <SectionWrapper data-id="element-89">
      <div className="space-y-8" data-id="element-90">
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-primary mb-8" data-id="element-91">
          El problema no es que tu hijo sea "malo" o que tú seas un "mal padre".
        </h2>

        <div className="prose prose-lg text-secondary font-body leading-relaxed" data-id="element-92">
          <p data-id="element-93">
            El problema es que el cerebro adolescente está programado
            biológicamente para rechazar la lógica adulta cuando siente presión
            emocional.
          </p>

          <p className="mt-6" data-id="element-94">
            Cada vez que intentas razonar, dar un consejo no solicitado o
            levantar la voz para recuperar la autoridad, su cerebro detecta una
            amenaza. El resultado es siempre el mismo: él se encierra más en su
            búnker y tú te quedas fuera, con una mezcla de impotencia, culpa y
            tristeza.
          </p>
        </div>
      </div>
    </SectionWrapper>;
}